import { useEffect } from 'react';
import { UnitEmergencyDto } from '@mark43/cad-api';
import { usePlaySound } from '../sounds/play-sound-provider';
import { usePrevious } from '../common/hooks/use-previous';

export function useHandleUnitEmergencySoundAlert({
    filteredUnAckedUnitEmergencies,
}: {
    filteredUnAckedUnitEmergencies: UnitEmergencyDto[];
}) {
    const { playSound } = usePlaySound();
    const previousFilteredUnAckedUnitEmergencies = usePrevious(filteredUnAckedUnitEmergencies);

    useEffect(() => {
        if (!filteredUnAckedUnitEmergencies?.length) {
            return;
        }

        if (
            !previousFilteredUnAckedUnitEmergencies ||
            (previousFilteredUnAckedUnitEmergencies &&
                filteredUnAckedUnitEmergencies.length >
                    previousFilteredUnAckedUnitEmergencies.length)
        ) {
            playSound('emergency-siren');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filteredUnAckedUnitEmergencies]);
}
